import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import PlaybookTemplateCreateQuery$parameters from '@atlassian/jira-relay/src/__generated__/PlaybookTemplateCreateQuery$parameters';

const playbookTemplateCreateViewEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-spa-apps-playbooks-template-create" */ './src'),
	),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => {
		const { projectKey, templateId = '' } = context.match.params;
		if (!projectKey) {
			throw new Error('projectKey is required');
		}

		const { cloudId, activationId } = tenantContext;
		const playbookAri = toPlaybookAri({
			siteId: cloudId,
			activationId,
			playbookId: '',
		});

		return {
			queries: {
				PlaybookTemplateCreateQuery: {
					parameters: PlaybookTemplateCreateQuery$parameters,
					variables: {
						cloudId,
						projectKey,
						templateId: templateId ?? '',
					},
				},
			},
			extraProps: {
				playbookAri,
				isNew: true,
				variant: 'new' as const,
				templateId: templateId ?? '',
			},
		};
	},
});

export default playbookTemplateCreateViewEntryPoint;

function toPlaybookAri({
	siteId,
	activationId,
	playbookId,
}: {
	siteId: string;
	activationId: string;
	playbookId: string;
}) {
	return `ari:cloud:jira:${siteId}:playbook/activation/${activationId}/${playbookId}`;
}
